import type { ReactNode } from 'react';

import classNames from 'classnames';

export interface PoolStat {
  id: string;
  label: ReactNode;
  content: ReactNode;
  tooltip?: ReactNode;
}

export const PoolStatList = ({ items, className }: { className?: string; items: PoolStat[] }) => {
  return (
    <ul className={classNames('flex flex-col border-t border-primary-100', className)}>
      {items.map(({ id, label, content, tooltip }) => {
        return (
          <li key={id} className="flex justify-between items-center h-9">
            <span className="text-sm text-neutral-500 font-medium uppercase">{label}</span>

            <span className="font-semibold">
              {content}
              {tooltip ? tooltip : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default PoolStatList;
